export default __webpack_public_path__ + "static/media/CV Alejandro Burgos Moreno 06-2022.39f057b8.pdf";